import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useAttention } from './AttentionContext';

interface TrackedTabsProps {
  defaultValue: string;
  children: React.ReactNode;
  className?: string;
  onValueChange?: (value: string) => void;
}

/**
 * A Tabs wrapper that automatically tracks tab switches for attention metrics.
 */
export function TrackedTabs({ 
  defaultValue, 
  children, 
  className,
  onValueChange 
}: TrackedTabsProps) {
  const attention = useAttention();

  const handleValueChange = (value: string) => {
    // Track the tab switch
    if (attention) {
      attention.trackTabSwitch(value);
    }
    // Call original handler
    if (onValueChange) {
      onValueChange(value);
    }
  };

  return (
    <Tabs 
      defaultValue={defaultValue} 
      className={className}
      onValueChange={handleValueChange}
    >
      {children}
    </Tabs>
  );
}

// Re-export the other tab components for convenience
export { TabsContent, TabsList, TabsTrigger };
